import MasterCrudPage from "../../components/MasterCrudPage";
import { callToActionMasterApi } from "../../api/masterApi";

export default function CallToActionMaster() {
  return (
    <MasterCrudPage
      title="Call to Action Master"
      description="Manage call to action labels such as Book Now, Enrol Now, Explore."
      idKey="call_to_action_id"
      api={callToActionMasterApi}
      listLabel="call to actions"
      useJson
      fields={[
        {
          name: "call_to_action",
          label: "Call to Action",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. Book Now, Enrol Now, Explore",
        },
      ]}
      columns={[
        { key: "call_to_action_id", label: "Call to Action" },
        { key: "call_to_action", label: "Call to Action" },
      ]}
    />
  );
}
